import { render } from "./PalmAndTreesByCount.vue?vue&type=template&id=7b7c2ec2"
import script from "./PalmAndTreesByCount.vue?vue&type=script&lang=js"
export * from "./PalmAndTreesByCount.vue?vue&type=script&lang=js"
script.render = render

export default script